var PageMyDocuments = (function ($) {
    
    PageMyDocuments = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$load_more_wrapper = that.$wrapper.find('.js-load-more-wrapper');
        that.$load_more_button = that.$wrapper.find('.js-list');
        that.$document_data_add = that.$wrapper.find('.js-button-add-document');
        that.$documents_list = that.$wrapper.find('.js-list');

        // OPTIONS
        that.page = options['page'];
        that.skeleton = options['skeleton'] || {};
        that.locales = options['locales'] || {};
        that.icons_path = options['icons_path'] || {};

        that.classes = {
            document_data_edit: '.js-document-edit',
            sticky_observer: 'js-sticky-observer',
            is_stick: 'is-stick',
            disabled: 'disabled'
        }
        
        // INIT
        that.init();
    };

    PageMyDocuments.prototype.init = function () {
        var that = this;
        
        $.sa.stickyObserver('.' + that.classes.sticky_observer, that.classes.is_stick);

        that.__initDocumentDataButtons();

        that.initPagination();
    };

    PageMyDocuments.prototype.initPagination = function () {
        var that = this,
            list_url = $.sa.build_url('my/documents/list');
        
        $.sa.pagination(that.$wrapper, list_url);
    };

    PageMyDocuments.prototype.__initDocumentDataButtons = function () {
        var that = this;

        that.$document_data_add.on('click', function () {
            that.__renderDocumentDataDrawer();
        });
        that.$wrapper.on('click', that.classes.document_data_edit, function (e) {
            var $button = $(e.currentTarget); // TODO !!!
            
            that.__renderDocumentDataDrawer($button.data('id'));
        });
    };

    PageMyDocuments.prototype.__renderDocumentDataDrawer = function (id) {
        var that = this;

        $.uiDrawer({
            position: 'right',
            size: 'small',
            mobile_fullscreen: true,
            header_title: that.locales['document'],
            content: that.skeleton['edit_drawer'],
            onOpen: function ($drawer_wrapper, drawer) {
                var href = $.sa.build_url('my/documents/edit'),
                    data = {
                        id: id
                    };

                $.post(href, data, function (html) {
                    drawer.setBody($(html).html());
                }).fail(function () {
                    drawer.close();
                    $.sa.handleErrors();
                });
            },
        });
    };
    
    return PageMyDocuments;
})($);